import { jsx as _jsx } from "react/jsx-runtime";
import { TooltipStyled, sxTooltip } from './InfoTooltip.styled';
import { forwardRef } from 'react';
// TODO: rename to something that explains the tooltip occurs on wrong use input or copy to clipboard...
// MB: ActionHelperTooltip?
const InfoTooltip = forwardRef(({ className, ...props }, ref) => {
    return (
    // Styling not working without xs for some reason. Check ErrorTooltip it is working there.
    _jsx(TooltipStyled, { ...props, 
        // arrow
        ref: ref, classes: { popper: className }, slotProps: {
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -8],
                        },
                    },
                    // {
                    // 	name: 'arrow',
                    // 	enabled: true,
                    // 	options: {
                    // 		padding: ({ popper }) => {
                    // 			return popper.width - 15;
                    // 		},
                    // 	},
                    // },
                ],
            },
            tooltip: { sx: sxTooltip },
            arrow: {},
        } }));
});
export { InfoTooltip };
